import React from 'react';
import PropTypes from 'prop-types';
import ImageOverlay from './ImageOverlay';
import { imageShape } from '../shapes/ImageShapes';

const styles = {
  imageOverlayWrapper: {
    position: 'absolute',
    // Align with the canvas pixels inside its one-pixel border.
    top: '1px',
  },
};

const DraggableOverlayLayer = ({ images, width, height, scale, onDragEnd, onInteractionChange, getImageDimensions }) => {
  return (
    <div
      style={{
        ...styles.imageOverlayWrapper,
        width: width,
        height: height,
        left: `calc(50% + ${-1 * (width / 2)}px)`,
      }}
    >
      {images.map((image) => {
        const { minX, minY, width: w, height: h } = getImageDimensions(image);
        return (
          <ImageOverlay
            scale={scale}
            key={image.name}
            name={image.name}
            x={minX}
            y={minY}
            width={w}
            height={h}
            onDragEnd={onDragEnd}
            onInteractionChange={onInteractionChange}
          />
        );
      })}
    </div>
  );
};

DraggableOverlayLayer.propTypes = {
  images: PropTypes.arrayOf(imageShape).isRequired,
  scale: PropTypes.number,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  onInteractionChange: PropTypes.func,
  getImageDimensions: PropTypes.func.isRequired,
};

export default React.memo(DraggableOverlayLayer);
